/**
 * Klucze elementów interfejsu z centrum ról (decyzja użytkownika 22.10.2026,
 * „Co widzi”; przełącznik `roleCenter`, S-22.10-01) — te same co w katalogu
 * API (`apps/api/src/role-center/ui-elements.ts`). Klucze to dane (wiersze
 * w bazie) — nie przemianowujemy ich. Pozycje menu mają klucz `menu.<zasób>`
 * (`menuElementKey` w `menuConfig.ts`).
 *
 * Test `roleCenter/elementKeys.test.ts` czyta plik API i pilnuje, że każdy
 * klucz stąd jest w katalogu, a pozycje menu mają w katalogu to samo
 * uprawnienie co w `menuConfig.ts`.
 */
export const ELEMENT = {
  orderVehicleSuggestions: 'order.vehicleSuggestions',
  orderTradeCarriers: 'order.tradeCarriers',
  orderCarrierOffers: 'order.carrierOffers',
  orderPublications: 'order.publications',
  preOrderActions: 'preOrder.actions',
  orderFromMailWriteDetails: 'orderFromMail.writeDetails',
  orderFromMailViaWrite: 'orderFromMail.viaWrite',
  fleetCarCard: 'fleet.carCard',
  dashboardFleet: 'dashboard.fleet',
  dashboardCarriersOnFile: 'dashboard.carriersOnFile',
  dashboardFleetDataGaps: 'dashboard.fleetDataGaps',
  userOffersMyVehiclesToggle: 'userOffers.myVehiclesToggle',
  userMenuCaretaker: 'userMenu.caretaker',
  userMenuExchangeAccount: 'userMenu.exchangeAccount',
} as const;

export type ElementKey = (typeof ELEMENT)[keyof typeof ELEMENT];
